
export const servicedCities = [
  { name: "Minneapolis", path: "/minneapolis" },
  { name: "St. Paul", path: "/st-paul" },
  { name: "Eden Prairie", path: "/eden-prairie" },
  { name: "Plymouth", path: "/plymouth" },
  { name: "Minnetonka", path: "/minnetonka" },
  { name: "Maple Grove", path: "/maple-grove" },
  { name: "Osseo", path: "/osseo" },
  { name: "Brooklyn Park", path: "/brooklyn-park" },
  { name: "Edina", path: "/edina" },
  { name: "Hopkins", path: "/hopkins" },
  { name: "St. Louis Park", path: "/st-louis-park" },
  { name: "Crystal", path: "/crystal" },
  { name: "Burnsville", path: "/burnsville" },
  { name: "Mound", path: "/mound" },
  { name: "Excelsior", path: "/excelsior" },
  { name: "Rockford", path: "/rockford" },
  { name: "Golden Valley", path: "/golden-valley" },
  { name: "New Brighton", path: "/new-brighton" },
].sort((a, b) => a.name.localeCompare(b.name));
